import { useTranslation } from 'react-i18next';
import { DollarSign, TrendingUp, Target } from 'lucide-react';

export default function KpiStrip({ deal }) {
  const { t } = useTranslation();
  const items = [
    {
      label: t('decision.monthlyCF'), value: deal.monthly_cash_flow,
      sign: true, icon: DollarSign, suffix: t('decision.perMonth'),
      pos: 'text-emerald-500 bg-emerald-500/[0.07] border-emerald-500/20',
      neg: 'text-red-500 bg-red-500/[0.07] border-red-500/20',
    },
    {
      label: t('decision.annualCF'), value: deal.annual_cash_flow,
      sign: true, icon: TrendingUp, suffix: t('decision.perYear'),
      pos: 'text-emerald-500 bg-emerald-500/[0.07] border-emerald-500/20',
      neg: 'text-red-500 bg-red-500/[0.07] border-red-500/20',
    },
    {
      label: t('decision.suggestedOffer'), value: deal.suggested_offer_price,
      sign: false, icon: Target, suffix: '',
      pos: 'text-blue-500 bg-blue-500/[0.07] border-blue-500/20',
      neg: 'text-blue-500 bg-blue-500/[0.07] border-blue-500/20',
    },
  ];

  return (
    <div data-testid="kpi-strip" className="grid grid-cols-1 sm:grid-cols-3 gap-3">
      {items.map(({ label, value, sign, icon: Icon, suffix, pos, neg }) => {
        const cls = value >= 0 ? pos : neg;
        const colorCls = cls.split(' ')[0];
        return (
          <div key={label} className={`border rounded-xl p-4 ${cls}`}>
            <div className="flex items-center gap-2 mb-1">
              <Icon className={`w-4 h-4 ${colorCls}`} />
              <span className="text-xs font-medium text-slate-500 dark:text-slate-400">{label}</span>
            </div>
            <p className={`text-2xl font-black tabular-nums ${colorCls}`}>
              {sign && value >= 0 ? '+' : sign && value < 0 ? '-' : ''}${Math.abs(Math.round(value)).toLocaleString()}
            </p>
            {suffix && <span className="text-[10px] text-slate-400">{suffix}</span>}
          </div>
        );
      })}
    </div>
  );
}
